import { Link } from 'react-router-dom';
import Avatar from '../ui/Avatar';

const SeriesCard = ({ series }) => {
  if (!series) return null;
  return (
    <Link
      to={`/series/${series.id}`}
      className="flex-shrink-0 w-56 bg-white dark:bg-slate-800 rounded-2xl border border-gray-200 dark:border-slate-700 overflow-hidden hover:shadow-lg transition-all"
    >
      <div className="aspect-[3/4] bg-gray-100 dark:bg-slate-700">
        {series.coverUrl ? (
          <img src={series.coverUrl} alt={series.title} className="w-full h-full object-cover" loading="lazy" />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-indigo-600 to-purple-600" />
        )}
      </div>
      <div className="p-3">
        <div className="flex items-center gap-2">
          <Avatar
            src={series.ownerPhotoURL}
            alt={series.ownerName}
            fallbackText={series.ownerName}
            size="sm"
          />
          <div className="min-w-0">
            <p className="text-sm font-semibold text-gray-900 dark:text-white truncate">{series.title}</p>
            <p className="text-xs text-gray-500 dark:text-gray-400 truncate">{series.ownerName}</p>
          </div>
        </div>
        <div className="mt-2 flex items-center justify-between text-xs text-gray-500 dark:text-gray-400">
          <span>{series.episodesCount || 0} episodios</span>
          <span>{series.followersCount || 0} seguidores</span>
        </div>
      </div>
    </Link>
  );
};

export default SeriesCard;

